module.exports = __webpack_public_path__ + "media/images/city/004-palais-garnier-83b40cc1bb542651fc9cf84b785a0a34.svg";